import React, { Fragment } from 'react';
import { Col, Row } from 'reactstrap';
import Skeleton from 'react-loading-skeleton';

const LoadingList = function(props) {
    return (
        <Fragment>
            <Row className="mt-4">
                <Col md="1">
                    <Skeleton />
                </Col>
                <Col md="5">
                    <Skeleton />
                </Col>
            </Row>
            <Row className="mt-3">
                <Col md="1">
                    <Skeleton height={60} />
                </Col>
                <Col md="6">
                    <Skeleton height={60} />
                </Col>
                <Col md="5">
                    <Skeleton height={60} />
                </Col>
            </Row>
            <Row className="mt-3">
                <Col md="1">
                    <Skeleton />
                </Col>
                <Col md="6">
                    <Skeleton />
                </Col>
                <Col md="5">
                    <Skeleton />
                </Col>
            </Row>
            <Row className="mt-3">
                <Col md="1">
                    <Skeleton />
                </Col>
                <Col md="6">
                    <Skeleton />
                </Col>
                <Col md="5">
                    <Skeleton />
                </Col>
            </Row>
            <Row className="mt-3">
                <Col md="1">
                    <Skeleton />
                </Col>
                <Col md="6">
                    <Skeleton />
                </Col>
                <Col md="5">
                    <Skeleton />
                </Col>
            </Row>
        </Fragment>
    );
};

export default LoadingList;
